angular.
module("dx.webapp.lists").
factory("dxSearchSortOptions", function searchSortOptionsService() {
	"use strict";

	var examTemplates = {
		searchableProperties: ["title", "subject"],
		sortOptions: [
			{value: "-modified", name: "SearchSortFilter.DateModified"},
			{value: "title", name: "SearchSortFilter.Title"},
			{value: "subject", name: "SearchSortFilter.Subject"},
		],
		searchPlaceholder: "SearchSortFilter.FilterByTitleOrSubject",
	};

	var exams = {
		searchableProperties: ["title", "id", "group"],
		sortOptions: [
			{value: "-modified", name: "SearchSortFilter.DateModified"},
			{value: "title", name: "SearchSortFilter.Title"},
			{value: "-start", name: "SearchSortFilter.StartTime"},
		],
		searchPlaceholder: "SearchSortFilter.FilterByTitleExamIDOrGroup",
	};

	var scheduledExams = {
		searchableProperties: ["title", "id", "group"],
		sortOptions: [
			{value: scheduledExamsStartSort, name: "SearchSortFilter.StartTime"},
			{value: "title", name: "SearchSortFilter.Title"},
		],
		searchPlaceholder: "SearchSortFilter.FilterByTitleExamIDOrGroup",
	};

	var ongoingExams = {
		searchableProperties: ["title", "id", "group"],
		sortOptions: [
			{value: "-start", name: "SearchSortFilter.StartTime"},
			{value: "title", name: "SearchSortFilter.Title"},
		],
		searchPlaceholder: "SearchSortFilter.FilterByTitleExamIDOrGroup",
	};

	function scheduledExamsStartSort(a, b) {
		if (a.start === "0001-01-01T00:00:00Z") {
			return 1;
		}

		if (b.start === "0001-01-01T00:00:00Z") {
			return -1;
		}

		if (a.start < b.start) {
			return -1;
		}

		if (a.start > b.start) {
			return 1;
		}

		return 0;
	}

	return {
		examTemplates: examTemplates,
		exams: exams,
		scheduledExams: scheduledExams,
		ongoingExams: ongoingExams,
	};
});
